import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex min-h-screen bg-gray-100 text-gray-800" }
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = {
  key: 0,
  class: "mobile-user-profile"
}
const _hoisted_4 = { class: "user-info" }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = { class: "user-email" }
const _hoisted_7 = { class: "flex-1 p-4 space-y-1" }
const _hoisted_8 = { class: "account-content" }

import { ref, onMounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router'
import ConfirmPopup from 'primevue/confirmpopup';
import Toast from 'primevue/toast';
import Button from 'primevue/button';
import Avatar from 'primevue/avatar';
import axiosInstance from "@/api/axios";
import {useToast} from "primevue";
import dfAvatar from '@/assets/images/avatar.png';


export default {
  __name: 'AccountLayout',
  setup(__props) {

const route = useRoute();
const type = ref(localStorage.getItem('type'));

const isActive = (path) => route.path === path

const menu = ref([]);
const isSidebarOpen = ref(false);
const isMobile = ref(false);
const user = ref({});

const userAvatar = computed(() => {
    return user.value.logo_path || dfAvatar;
});

const menuSpecialist = ref([
    {
        label: 'Dane podstawowe',
        to: '/account/settings',
        icon: 'pi pi-home'
    },
    {
        label: 'Dane lokalizacyjne',
        to: '/account/localization',
        icon: 'pi pi-map-marker'
    },
    {
        label: 'Dane kontaktowe',
        to: '/account/contact',
        icon: 'pi pi-phone'
    },
    {
        label: 'Dostępność i Rezerwacje',
        to: '/account/reservations',
        icon: 'pi pi-calendar-clock'
    },
    {
        label: 'Usługi i Cennik',
        to: '/account/services',
        icon: 'pi pi-dollar'
    },
    {
        label: 'Opinie i Oceny',
        to: '/account/opinions',
        icon: 'pi pi-comment'
    },
    {
        label: 'Widoczność i promowanie profilu',
        to: '/account/premium',
        icon: 'pi pi-star'
    },
])

const menuClient = ref([
    {
        label: 'Dane podstawowe',
        to: '/account/settings',
        icon: 'pi pi-home'
    },
    {
        label: 'Rezerwacje',
        to: '/account/reservations',
        icon: 'pi pi-calendar-clock'
    },
]);

const verifiedEmail = ref(null);
const toast = useToast();

// Check if device is mobile
const checkMobile = () => {
    isMobile.value = window.innerWidth <= 768;
    if (!isMobile.value) {
        isSidebarOpen.value = false;
    }
};

const toggleSidebar = () => {
    if (isMobile.value) {
        isSidebarOpen.value = !isSidebarOpen.value;
    }
};

const closeSidebar = () => {
    isSidebarOpen.value = false;
};

const getUser = async () => {
    try {
        const url = `/users/find`;
        const response = await axiosInstance.get(url);
        if (response.status === 200) {
            user.value = response.data.data;
        }
    } catch (error) {
        console.log(error);
    }
};

onMounted(async function () {
    if (type.value === 'client') {
        menu.value = menuClient.value;
    }
    if (type.value === 'specialist') {
        menu.value = menuSpecialist.value;
    }

    checkMobile();
    window.addEventListener('resize', checkMobile);

    await getUser();
    await find();

    if (window.location.pathname === '/vue/account/settings' || window.location.pathname === '/account/settings') {
        verifiedEmail.value = true;
    }
});

const isLoading = ref(false);
const sendCode = async () => {
    try {
        isLoading.value = true;
        const url = `/users/resend-verification-code`;
        const response = await axiosInstance.post(url);
        if (response.status === 200) {
            if (response.data.success === true) {
                toast.add({ severity: 'success', summary: 'Success!', detail: 'Wiadomość z linkiem została wysłana', life: 3000 });
            } else  {
                toast.add({ severity: 'error', summary: 'Error!', detail: 'Nie udało się wysłać wiadomości', life: 3000 });
            }
        }

        isLoading.value = false;
    } catch (error) {
        toast.add({ severity: 'error', summary: 'Error!', detail: 'Nie udało się wysłać wiadomości', life: 3000 });
        isLoading.value = false;
    }
}

const find = async () => {
    try {
        const url = '/users/find';
        const response = await axiosInstance.get(url);
        if (response.status === 200) {
            const userData = response.data.data;
            if (userData.email_verified_at) {
                verifiedEmail.value = true;
            } else  {
                verifiedEmail.value = false;
            }
        }
    } catch (error) {
        console.log(error)
        verifiedEmail.value = false;
    }
}

watch(() => route.path, async () => {
    await find();
    if (window.location.pathname === '/vue/account/settings' || window.location.pathname === '/account/settings') {
        verifiedEmail.value = true;
    }
});

return (_ctx, _cache) => {
  const _component_TopNav = _resolveComponent("TopNav")
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")
  const _component_Message = _resolveComponent("Message")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TopNav, { onToggleSidebar: toggleSidebar }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("aside", {
        class: _normalizeClass(["sidebar", { 'sidebar-open': isSidebarOpen.value }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          (isMobile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(Avatar), {
                  image: userAvatar.value,
                  shape: "circle",
                  size: "large"
                }, null, 8, ["image"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h3", _hoisted_5, _toDisplayString(user.value.display_name || 'Użytkownik'), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(user.value.email || ''), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (isMobile.value)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                icon: "pi pi-times",
                text: "",
                onClick: closeSidebar,
                class: "close-sidebar-btn"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("nav", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.to,
              to: item.to,
              onClick: closeSidebar
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(["menu-icon", item.icon])
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ], 2),
      (isMobile.value && isSidebarOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "sidebar-overlay",
            onClick: closeSidebar
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (verifiedEmail.value)
          ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
          : _createCommentVNode("", true),
        (verifiedEmail.value === false)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 1,
              severity: "error"
            }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createTextVNode(" Konto nie zostało aktywowane. Na Twój adres e-mail wysłano wiadomość aktywacyjną. Jeśli wiadomość nie dotarła, wyślij ją ponownie: ")),
                _createVNode(_unref(Button), {
                  class: "m-2",
                  onClick: sendCode,
                  severity: "info",
                  loading: isLoading.value,
                  label: "Wyślij ponownie link weryfikacyjny"
                }, null, 8, ["loading"])
              ]),
              _: 1,
              __: [0]
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(Toast)),
    _createVNode(_unref(ConfirmPopup))
  ], 64))
}
}

}